import React from "react";
import {
  LayoutDashboard, Network, Building2, FileText, AlertTriangle, BarChart3, Settings, PanelLeftClose, ScrollText,
} from "lucide-react";
import { LogoMark } from "./Logo";

export type PageId = "dashboard" | "struktur" | "perusahaan" | "dokumen" | "issues" | "laporan" | "aktivitas" | "pengaturan";

const NAV: { id: PageId; label: string; icon: React.ComponentType<any>; adminOnly?: boolean }[] = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { id: "struktur", label: "Struktur", icon: Network },
  { id: "perusahaan", label: "Perusahaan", icon: Building2 },
  { id: "dokumen", label: "Dokumen", icon: FileText },
  { id: "issues", label: "Data Issues", icon: AlertTriangle },
  { id: "laporan", label: "Laporan", icon: BarChart3 },
  { id: "aktivitas", label: "Log Aktivitas", icon: ScrollText, adminOnly: true },
  { id: "pengaturan", label: "Pengaturan", icon: Settings },
];

interface Props {
  page: PageId;
  onNavigate: (p: PageId) => void;
  issueCount: number;
  mini: boolean;
  onToggleMini: () => void;
  isAdmin: boolean;
}

export default function Sidebar({ page, onNavigate, issueCount, mini, onToggleMini, isAdmin }: Props) {
  return (
    <aside className={"side" + (mini ? " mini" : "")} data-testid="sidebar">
      <button className="side-collapse-btn" onClick={onToggleMini} data-testid="sidebar-toggle" aria-label="Ciutkan menu">
        <PanelLeftClose size={18} />
      </button>
      <div className="side-brand">
        <div className="side-brand-mark"><LogoMark size={26} tone="onDark" /></div>
        <div className="side-brand-txt">
          <span className="side-brand-word">STRUKTURKU</span>
          <span className="side-brand-sub">by Abadi Premium Consultant</span>
        </div>
      </div>

      <nav className="side-nav">
        {NAV.filter((n) => !n.adminOnly || isAdmin).map((n) => {
          const Icon = n.icon;
          const active = page === n.id;
          return (
            <button
              key={n.id}
              className={"side-item" + (active ? " active" : "")}
              onClick={() => onNavigate(n.id)}
              data-testid={`nav-${n.id}`}
              title={n.label}
            >
              <span className="side-ic"><Icon size={19} strokeWidth={2} /></span>
              <span className="side-lbl">{n.label}</span>
              {n.id === "issues" && issueCount > 0 && (
                <span className="side-badge" data-testid="nav-issues-badge">{issueCount}</span>
              )}
            </button>
          );
        })}
      </nav>

      <div className="side-foot">
        <div className="side-foot-glow" />
        <div className="side-foot-msg">Struktur yang Lebih Jelas untuk Keputusan yang Lebih Baik.</div>
        <div className="side-foot-rule" />
        <div className="side-foot-word">STRUKTURKU</div>
        <div className="side-foot-by">by Abadi Premium Consultant</div>
        <div className="side-foot-ver">v1.0.0</div>
      </div>
    </aside>
  );
}
